var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn btn-primary",attrs:{"disabled":_vm.submitting}},[_c('save-icon'),(_vm.submitting)?[_vm._v("Zapisuję...")]:[_vm._v("Zapisz")]],2)}
var staticRenderFns = []

export { render, staticRenderFns }